import {useState, useEffect} from 'react';
import {translations} from 'presentation/translations-new';
import {formatTimeRemaining} from '../../utils/formatTimeRemaining';

const {expiredToken} = translations['pt-br'].privateFlow.token;

export function useCountdown(initialCountInSeconds: number) {
	const [timeRemainingState, setTimeRemainingState] = useState(initialCountInSeconds);
	const [progressValueState, setProgressValueState] = useState(100);
	const [endTimeState] = useState(Date.now() + initialCountInSeconds * 1000);

	const isExpired = timeRemainingState <= 0 || initialCountInSeconds <= 0;

	useEffect(() => {
		const timerInterval = setInterval(() => {
			const currentTime = Date.now();
			const timeLeft = Math.max(0, Math.floor((endTimeState - currentTime) / 1000));
			const timeElapsed = Math.max(
				0,
				initialCountInSeconds - Math.floor((endTimeState - currentTime) / 1000),
			);
			const newProgressValue = 100 - (timeElapsed / initialCountInSeconds) * 100;

			setProgressValueState(newProgressValue);
			setTimeRemainingState(timeLeft);

			if (timeLeft === 0 || newProgressValue <= 0 || newProgressValue >= 100) {
				clearInterval(timerInterval);
			}
		}, 1000);

		return () => clearInterval(timerInterval);
	}, [endTimeState, initialCountInSeconds]);

	const timeRemainingFormatted = formatTimeRemaining(timeRemainingState);
	const counterValueState = isExpired ? expiredToken : timeRemainingFormatted;

	return {
		progressValue: progressValueState,
		isExpired,
		counterValue: counterValueState,
	};
}
